import { store } from 'v3/data/store';
import { rankSellerSlice } from 'v3/data/store/Rank/RankSeller';
import { IRankSellerList, ISellerRankingReportState, ISellerRankState, SellerRankingReportStatus } from 'v3/data/store/Rank/RankSeller/types';

export const setRankSellerList = (array: IRankSellerList) => {
  store.dispatch(rankSellerSlice.actions.setRankList(array));
};

export const setFilterRowsPerPage = (value: number) => {
  store.dispatch(rankSellerSlice.actions.setFilterRowsPerPage(value));
};

export const setFilterCurrentPage = (value: number) => {
  store.dispatch(rankSellerSlice.actions.setFilterCurrentPage(value));
};

export const setUpdateSellerRankFilter = (value: Partial<ISellerRankState['filter']>) => {
  store.dispatch(rankSellerSlice.actions.updateFilter(value));
};

export const setSellerStartDate = (value: string) => {
  store.dispatch(rankSellerSlice.actions.setStartDate(value));
};

export const setSellerFinalDate = (value: string) => {
  store.dispatch(rankSellerSlice.actions.setFinalDate(value));
};

export const resetSellerRankFilter = () => {
  store.dispatch(rankSellerSlice.actions.resetFilter());
};

export const setReportJobId = (value: string | null) => {
  store.dispatch(rankSellerSlice.actions.setReportJobId(value));
};

export const setReportStatus = (value: SellerRankingReportStatus) => {
  store.dispatch(rankSellerSlice.actions.setReportStatus(value));
};

export const setReportDownloadUrl = (value: string | null) => {
  store.dispatch(rankSellerSlice.actions.setReportUrl(value));
};

export const setReportState = (value: ISellerRankingReportState) => {
  store.dispatch(rankSellerSlice.actions.setReportState(value));
};

export const resetReportState = () => {
  store.dispatch(rankSellerSlice.actions.resetReportState());
};
